import React, { FC } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useGlobalModel from "@/model/globalModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useSaleRoDetailModel } from "./saleRoDetailModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { formatNum } from "@/utils/utils";

export const FixedBottom: FC<RouterParamType> = ({ id, mode }) => {

    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { cm, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { addDesc, editDesc, lookDesc } = useSaleRoDetailModel();
    const typeDesc = {
        add: addDesc,
        edit: editDesc,
        look: lookDesc
    }
    const orderStatistics: IDescription[] = [
        {
            label: Locale["Return Qty"],// "退货数量",
            value: (typeDesc[mode].numAll),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: Locale["Return Item Number"],// "退货项数",
            value: typeDesc[mode].itemNumAll,
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: Locale["taxation"],//"税费",
            value: formatNum(typeDesc[mode].taxationAll),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: Locale["Return Amount"],//"退货金额",
            value: formatNum(typeDesc[mode].totalAll),
            color: DescriptionColorEnum.green,
            status: true
        }
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${cm.collapsed ? '80px' : '226px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}